"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Typography = _interopRequireDefault(require("../../../../atoms/Typography/index.js"));
var _CommonUtility = require("../../../../../utils/CommonUtility.js");
var _react = _interopRequireWildcard(require("react"));
require("./pieLegend.css");
var _styledComponent = require("./styledComponent.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const PieLegend = props => {
  const {
    data,
    height,
    chartDataKey
  } = props;
  const total = (0, _react.useMemo)(() => {
    return data.reduce((prevData, currentData) => {
      return prevData + currentData[chartDataKey];
    }, 0);
  }, [data]);
  const getPercentage = value => {
    try {
      const percent = value / total * 100;
      return `${isNaN(percent) ? 0 : percent.toFixed(2)}%`;
    } catch {
      return `0%`;
    }
  };
  const [uniqueId] = (0, _react.useState)((0, _CommonUtility.generateUuidv4)());
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styledComponent.StyledLegend, {
    className: "mun-pie-legend",
    height: height,
    children: data.map((legendData, index) => {
      const value = legendData[chartDataKey];
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styledComponent.StyledLegendData, {
        className: "mun-pie-legend__data",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styledComponent.StyledLegendBackGround, {
          background: legendData.color,
          className: 'mun-pie-legend__data-color'
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          children: legendData.name
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          variant: "caption-light",
          children: ` - ${value} (${getPercentage(value)})`
        })]
      }, `${uniqueId}-legend-${index}`);
    })
  });
};
var _default = exports.default = PieLegend;
module.exports = exports.default;
module.exports.default = exports.default;